/**
 * The global Utils object.
 */
window.Utils =
{
    stripModelAlias: function(prefixedModelId)
    {
        return prefixedModelId.replace(/^.+_(.+)$/, "$1");
    },

	/**
	 * This method determines whether an array of models contain a given value for a given param.
	 *
	 * @param models
	 * @param propertyValue
	 * @param propertyName
	 * @returns boolean
	 */
	modelsContainValues: function(models, propertyValue, propertyName = 'id')
	{
		for (let i in models)
		{
			if (models[i][propertyName] == propertyValue)
			{
				return true;
			}
		}

		return false;
	},

	convertLength: function(value,from,to)
	{
		var metricSystems = {in:'us', ft:'us', yards:'us', mm:'metric', meters:'metric'};

		if(metricSystems[ from ] == '' || metricSystems[ to ] == '' || value == '')
		{
			return value;
		}

		//Normalize lengths to either inches or centimeters.
		if ( from == 'yards' )
			value *= 36;
		else if ( from == 'ft' )
			value *= 12;
		else if ( from == 'mm' )
			value /= 10;
		else if ( from == 'meters' )
			value *= 100;

		//Perform conversion between metric systems.
		if ( metricSystems[ from ] != metricSystems[ to ] ){
			if ( metricSystems[ from ] == 'us' )
				value *= 2.54;
			else
				value /= 2.54;
		}

		//De-Normalize lengths to required to-metric.
		if ( to == 'yards' )
			value /= 36;
		else if ( to == 'ft' )
			value /= 12;
		else if ( to == 'mm' )
			value *= 10;
		else if ( to == 'meters' )
			value /= 100;

		return value;
	},

	ucwords: function (str) {
		return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
			return $1.toUpperCase();
		});
	},

    /**
     * This accepts an array of objects that define Vue skeletons, and extends them each in sequence.
     * It returns the Vue instance build from the extended Vue skeleton.
     *
     * @return Object
     */
    VueSkeleton: function()
	{
        // Declare the function arguments as an array.
        var args = Array.prototype.slice.call(arguments);

        // Declare the extended Vue skeleton.
        var extended = $.extend.apply(null, [true, {}].concat(args));

        // Declare the array of top level Vue methods that can be merged.
        var mergeableMethods = {
            'created': [],
            'mounted': []
        };

        // Loop through each Vue skeleton which constructed the extended skeleton.
        for (var i in args)
        {
            // Declare the Vue skeleton.
            var vueSkeleton = args[i];

            // Loop through each mergeable method.
            for (var mergeableMethodName in mergeableMethods)
            {
                // If this skeleton defines the top level Vue method, then append it to the set of mergeable methods.
                if (vueSkeleton[mergeableMethodName])
                {
                    mergeableMethods[mergeableMethodName].push(vueSkeleton[mergeableMethodName]);
                }
            }
        }

        // Loop through each mergeable method and override it on the extended skeleton.
        for (mergeableMethodName in mergeableMethods)
        {
            // If the mergeable method is defined on the extended skeleton.
            if (extended[mergeableMethodName])
            {
                // Override the mergeable method with its merged array.
                extended[mergeableMethodName] = function(methods)
                {
                    return function()
                    {
                        for (var i = 0; i < methods.length; i++)
                        {
                            methods[i].call(this);
                        }
                    };
                }(mergeableMethods[mergeableMethodName]);
            }
        }

        return extended;
    },

    /**
	 * This accepts an array of objects that define Vue skeletons, and extends them each in sequence.
	 * It returns the Vue instance build from the extended Vue skeleton.
	 *
	 * @return Vue
     */
	Vue: function()
	{
		// Return the Vue instance constructed from the extended and merged Vue skeleton.
		return new Vue(this.VueSkeleton.apply(this, arguments));
	},

    /**
     * General logging function.
     *
     * @param message
     */
    log: function(message)
    {
        console.log('JS Log', message);

        Utils.ajax({
            type: 'POST',

            url: '/dshell/js-log',

            data:
            {
                message: message,

                request: {
                    url: window.location.href,
                    referrer: document.referrer,
                    userAgent: window.navigator.userAgent,
                    viewportSize: { width: window.innerWidth, height: window.innerHeight },
                    screenSize: { width: window.screen.width, height: window.screen.height },
                }
            }
        });
    },

    /**
     * General logging function.
     *
     * @param message
     */
    logRequest: function(message)
    {
        Utils.log(JSON.stringify({
            message: message,
            filename: url,
            lineno: lineNo,
            colno: columnNo,
            stack: JSON.stringify(error.stack),
            url: window.location.href,
            referrer: document.referrer,
            userAgent: window.navigator.userAgent,
            viewportSize: { width: window.innerWidth, height: window.innerHeight },
            screenSize: { width: window.screen.width, height: window.screen.height },
            // cookies: document.cookie, // Be careful with this
        }));
    },

	themeAjaxSuccess: function(obj, message)
	{
		var theme = '\
			<div class="alert alert-success fade in">\n\
				<a href="#" class="close" data-dismiss="alert">&times;</a>\n\
				<strong>Success!</strong> '+ message+'\n\
			</div>';

		this.themeAjaxResponse(obj, theme);
	},

	themeAjaxError: function(obj, message)
	{
		var theme = '\
			<div class="alert alert-danger fade in">\n\
				<a href="#" class="close" data-dismiss="alert">&times;</a>\n\
				<strong>Error!</strong> '+ message+'\n\
			</div>';

		this.themeAjaxResponse(obj, theme);
	},

	themeAjaxResponse: function(obj, theme)
	{
		obj.fadeIn();
		obj.html(theme);
		obj.fadeOut(5000);
	},

	/**
	 * This object manages loader buttons or anchors that call an AJAX action, upon the
	 * execution of which, it resets the button or anchor.
	 */
	loader: {

        /**
		 * Set the  tag as loading.
		 *
         * @param tag
         * @param color
         */
		call: function(tag, color)
		{
			// Default color to white.
			if (! color)
			{
				color = 'white';
			}

			// If a color is defined on the tag itself via a 'data-loading-color' attribute, then set it.
			if (tag.dataset.loadingColor)
			{
				color = tag.dataset.loadingColor;
			}

			// Disable tag.
			tag.disabled = true;

			// Reset the post success timer.
            if (tag.postSuccessTimer)
            {
                clearTimeout(tag.postSuccessTimer);

                // Revert the anchor tag's original inner HTML and class name.
                tag.innerHTML = tag.originalHtml;
                tag.className = tag.originalClassName;

                tag.postSuccessTimer = null;
            }

			// Unfocus tag.
			tag.blur();

			// Set the anchor's AJAX loading flag.
			tag.ajaxLoading = true;

			// Save the original width and height values.
			// tag.originalWidth = tag.style.width;
			// tag.originalHeight = tag.style.height;

			// Lock button dimensions.
			// tag.style.width = $(tag).width() +'px';
			// tag.style.height = $(tag).height() +'px';
			tag.style.width = $(tag).css('width');
			tag.style.height = $(tag).css('height');

			// Save the anchor tag's current inner HTML and class name.
			tag.originalHtml = tag.innerHTML;
			tag.originalClassName = tag.className

			// Clear the anchor's inner HTML.
			tag.innerHTML = '';

			// Change the link's class to the loading button class.
			if (tag.className === '')
			{
				tag.className = 'btn-loading btn-loading-'+ color;
			}
			else
			{
				tag.className += ' btn-loading btn-loading-'+ color;
			}
		},

		/**
		 * This resets the anchor tag to original pre-click conditions.
		 *
		 * @param tag
		 */
		reset: function(tag)
		{
			// Only attempt to reset if it's still loading.
			if (typeof tag === 'undefined' || typeof tag.ajaxLoading === 'undefined' || tag.ajaxLoading === false)
			{
				return;
			}

			// Reset the tag's dimensions.
			// tag.style.width = tag.originalWidth;
			// tag.style.height = tag.originalHeight;

			// Reset the anchor's AJAX loading flag.
			tag.ajaxLoading = false;

            // Revert the anchor tag's original inner HTML and class name.
			tag.innerHTML = tag.originalHtml;
            tag.className = tag.originalClassName;

			// Enable tag.
			tag.disabled = false;
		},

        /**
		 * This removes the loading style and places a success signifier to be auto-removed and
		 * reverted to the original HTML after some set time.
		 *
		 * @param tag
		 * @param callback
		 * @return void
         */
        success: function(tag, callback)
		{
            // Reset the tag's dimensions.
			// tag.style.width = tag.originalWidth;
			// tag.style.height = tag.originalHeight;

            // Reset the anchor's AJAX loading flag.
            tag.ajaxLoading = false;

            // Set tag's class to loading success.
            tag.className = tag.originalClassName +' btn-loading-success';

            // Reset the tag once the success animation is complete.
			tag.postSuccessTimer = setTimeout(function()
			{
                // Revert the anchor tag's original inner HTML and class name.
                tag.innerHTML = tag.originalHtml;
                tag.className = tag.originalClassName;

                // Enable tag.
                tag.disabled = false;

                if (callback)
				{
					callback();
				}
			}, 1500);
        }
	},

	/**
	 * This object manages the loading of partials via AJAX.
	 */
	partial:
	{
		// Declare the set of supported Bootbox types.
		types:
		{
			dialog: 'dialog',
			confirm: 'confirm',
			get list()
			{
				return [this.dialog, this.confirm];
			}
		},

		// Declare the set of supported Bootbox sizes.
		sizes:
		{
			small: 'small',
			medium: 'medium',
			large: 'large',
			get list()
			{
				return [this.small, this.medium, this.large];
			}
		},

		/**
		 * This function validates the show() arguments object.
		 */
		validateArgs: function (args)
		{
			// If a bootbox type is not provided, then default to the dialog type.
			if (!args.type)
			{
				args.type = this.types.dialog;
			}

			// If a bootbox size is not provided, then default to small.
			if (!args.size)
			{
				args.size = 'medium';
			}

			// If an anchor tag is not provided, then throw error.
			if (!args.anchorTag)
			{
				throw Error('An anchor tag reference is required!');
			}
			// Else, if a bootbox type is invalid, then throw error.
			else if ($.inArray(args.type, this.types.list) === -1)
			{
				throw Error('The partial type "'+ args.type +'" is invalid!');
			}
			// Else, if a bootbox size is invalid, then throw error.
			else if ($.inArray(args.size, this.sizes.list) === -1)
			{
				throw Error('The partial size "'+ args.size +'" is invalid!');
			}
			// Else, if a title is not provided.
			else if (!args.title)
			{
				throw Error('A title is required!');
			}
		},

		/**
		 * Load and show the partial via AJAX by clicking on a link.
		 *
		 * @param Object args
		 * @returns {undefined}
		 */
		show: function(args)
		{
			// If the partial is currently loading, then skip routine.
			if (args.anchorTag.ajaxLoading && args.anchorTag.ajaxLoading === true)
			{
				return;
			}

			// Validate args.
			this.validateArgs(args);

			// Set anchor as loading..
			Utils.loader.call(args.anchorTag, args.anchorColor || 'white');

			// Load the partial.
			$.ajax({
				type: 'GET',

				url: args.anchorTag.href,

				data: args.data || {},

				// On successful load.
				success: function(data)
				{
					this.successCallback(data, args);
				}.bind(this),// success

				// On error.
				error: function(jqXHR, textStatus, errorThrown)
				{
					this.errorCallback(jqXHR, textStatus, errorThrown, args);
				}.bind(this)// error
			});
		},

		/**
		 * This function defines the AJAX success callback.
		 */
		successCallback: function(response, args)
		{
			if (response.result === 'error')
			{
				throw Error(response.message);
			}

			// Reset anchor.
			Utils.loader.reset(args.anchorTag);

			// Declare the set of bootbox options.
			var options = {
				title: (response.title) ? response.title : args.title,
				message: response.body || response.data.body || 'Response Body Not Found',
				size: args.size
			};

			// Open the Bootbox.
			if (args.type === this.types.dialog)
			{
				options.buttons = args.buttons;

                var dialog = bootbox.dialog(options);
			}
			else if (args.type === this.types.confirm)
			{
                // If a callback function is not provided, then throw error.
                if (!args.callback)
                {
                    throw Error('A callbback function is required for confirm types!');
                }

                options.callback = args.callback;

                options.buttons = {
                    confirm: {
                        label: args.confirmLabel || 'Continue',
                        className: 'btn-success'
                    },
                    cancel: {
                        label: args.cancelLabel || 'Cancel',
                        className: 'btn-danger'
                    }
                };

				var dialog = bootbox.confirm(options);
			}
			else
			{
				throw Error("Unrecognized bootbox type '"+ args.type +"'!");
			}

			// Intitialize the modal box.
			if (args.init)
			{
                dialog.init(function()
                {
                    args.init(response.data);
                });
			}

			/**
			 * Apparently I stopped passing the dialog box reference.
			 *
			 * I'm not really sure why or whether this breaks anything.
			 *
			var dialog = bootbox[args.type](options);

			if (args.init)
			{
				dialog.init(args.init.bind(dialog[0]));
			}
			 *
			 */
		},

		/**
		 * This function defines the AJAX error callback.
		 */
		errorCallback: function(jqXHR, textStatus, errorThrown, args)
		{
            Utils.loader.reset(args.anchorTag);
			console.log(jqXHR);

			if (args.vueError && jqXHR.responseJSON)
            {
                args.vueError.vue.setMessage(args.vueError.messageName, jqXHR.responseJSON.message);
            }

			Utils.log("Loading partial failed: "+ JSON.stringify(jqXHR));
		}
	},// partial

    /**
	 * This method encodes an object for an HTTP AJAX request.
	 *
	 * @var Object obj
	 * @return Object
     */
    encodeHttp: function(obj)
	{
		for (var fieldName in obj)
		{
			// Skip the field if it's not the object's own field or if it doesn't have a mapping.
			if (! obj.hasOwnProperty(fieldName) || ! obj['$'+ fieldName])
			{
				continue;
			}

			// Declare the field value and its mapping.
			var
				fieldValue = obj[fieldName],
				mapping = obj['$'+ fieldName];

			// If the value is a null.
			if (fieldValue === null)
			{
				obj[fieldName] = '';
			}

			// If the field value isn't a primitive, then continue recursively encoding it.
			if (fieldValue instanceof Array || fieldValue instanceof Object)
			{
                /**
				 * TODO: I think that if fieldValue were actually an array then this would likely cause problems
				 * because it would be passed as a copy instead of by reference.
                 */
				this.encodeHttp(fieldValue);
			}
			// Else, if the value is a boolean.
			else if (typeof fieldValue === 'boolean' && mapping.type === 'boolean')
			{
                obj[fieldName] = (fieldValue === true) ? 1 : 0;
			}
		}

		return obj;
	},// encodeHttp()

    /**
     * This method decodes an object from an HTTP AJAX request.
     *
     * @var Object obj
     * @return Object
     */
    decodeHttp: function(obj)
    {
		for (var fieldName in obj)
        {
            // Skip mapping fields.
			if (fieldName.charAt(0) === '$')
			{
				continue;
			}

            // Declare the field value and its mapping.
            var
                fieldValue = obj[fieldName],
                mapping = obj['$'+ fieldName];

			// Skip decoding if there's no mapping.
			if (! mapping)
			{
                // If fieldValue is an object, then attempt to decode it.
                if (typeof fieldValue == 'object')
                {
                    this.decodeHttp(fieldValue);
                }

				continue;
			}

			// Decode based on mapping type.
			switch (mapping.type)
			{
				// Boolean
				case '2':
					if (typeof fieldValue === 'number')
					{
						obj[fieldName] = fieldValue == 1;
					}
					break;
				// If a to-one association, then continue recursively decoding it.
				case '11':
					this.decodeHttp(fieldValue);
					break;
				// If a to-many association, then continue recursively decoding its elements.
				case '12':
					for (let i in fieldValue)
					{
						this.decodeHttp(fieldValue[i]);
					}
					break;
			}

			// If the value is a null (mapping is nullable or is a to-one association).
            if ((mapping.nullable == 1 || mapping.type == '11') && fieldValue === '')
            {
                obj[fieldName] = null;
            }
        }

        return obj;
    },// decodeHttp()

	/**
	 * Get a deep clone of a JSON safe object.
	 *
	 * @param object
	 * @return Object
	 */
	clone: function(object)
	{
		return JSON.parse(JSON.stringify(object));
	},

    /**
     * Flags whether an AJAX request is currently running for a given URL.
     *
     * @var bool
     */
    ajaxRunning: {},

    /**
     * Unified AJAX call handler that also handles encoding and decoding HTTP/PHP values.
     *
     * @param obj
     * @param vue
     * @param messageName
     */
    ajax: function(obj, vue, messageName)
    {
        let
            messageVue = vue,
            messageMatch = (messageName) ? messageName.match(/^(.+)\.(.+)$/) : null;

        if (messageMatch)
        {
            messageVue = window[messageMatch[1]];
            messageName = messageMatch[2];
        }

        if (messageVue && this.ajaxRunning[obj.url] && this.ajaxRunning[obj.url] === true)
        {
            messageVue.setMessage(
                messageName,
                'Currently busy, please try again',
                // If a message delay is not defined, then default to 3 seconds.
                obj.successMessageDelay || 3000
            );

            return;
        }

        this.ajaxRunning[obj.url] = true;

        if (obj.attempt)
        {
            obj.attempt(vue);
        }

    	// Define whether this AJAX call is idempotent.
		let isIdempotent = obj.idempotent && obj.idempotent === true;

    	// Declare an idempotent key.
		let idempotencyKey = isIdempotent ? 'ds_'+ Date.now() +'_'+ Math.random() : null;

		// Declare flag that denotes whether this will be a POST request.
		let isPost = false;

		// Declare the form data for post requests.
		let formData = null;

		// Handle non standard request methods.
		switch (obj.type)
		{
			case 'POST':
			case 'PUT':
			case 'PATCH':
			case 'DELETE':
				isPost = true;

				break;
		}

		/**
		 * Declare the form data to send for post data.
		 *
		 * Using the FormData object is required here since method spoofing via the _method field
		 * potentially fails without it, presumably due to the size of certain objects being loaded
		 * onto request fields.
		 *
		 * In fact, apparently the form data only accepts key-value pairs so the only way to make
		 * this work is to use JSON.stringify.
		 */
		if (isPost)
		{
			formData = new FormData();
			formData.append('_method', obj.type);

			for (var key in obj.data)
			{
				if (! obj.data.hasOwnProperty(key))
				{
					continue;
				}

                let datum = obj.data[key];

                if (datum instanceof File)
                {
                    formData.append(key, datum, datum.name);
                }
				else if (datum == '')
				{
					formData.append(key, '');
				}
				else if (typeof datum == 'string')
                {
                    this.encodeHttp(datum);
                    formData.append(key, datum);
                }
                else
                {
                    formData.append(key, JSON.stringify(datum));
                }
			}

			obj.type = 'POST';
		}

        // Update selection.
        $.ajax({
            type: obj.type,

			beforeSend: function(xhr)
			{
            	if (isIdempotent)
				{
					xhr.setRequestHeader('Idempotency-Key', idempotencyKey);
				}

                /**
                 * For some reason this header was not being sent for some requests. The one in particular
                 * that was giving me trouble was idempotent, so perhaps something to do with that?
                 *
                 * TODO: This seems like a kludge.
                 */
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                if (obj.headers)
                {
                    for (let headerName in obj.headers)
                    {
                        xhr.setRequestHeader(headerName, obj.headers[headerName]);
                    }
                }
			},

            xhrFields:
            {
                // This is required in order to pass the session cookie from subdomain to domain.
                withCredentials: true
            },

            url: obj.url,

            data: isPost ? formData : $.param(obj.data || {}),

			dataType: 'json',

			cache: obj.cache || false,

			processData: obj.processData || false,

			contentType: obj.contentType || false,

			// Used for idempotency; the number of times this request has been tried.
			tryCount: 0,

            // On successful load.
            success: function(response)
            {
                if (obj.logResponse)
                {
                    console.log(response);
                }

                this.ajaxRunning[obj.url] = false;

                Utils.decodeHttp(response.data);

                if (response.status === 'success')
                {
                    // If a success function is defined.
                    if (obj.success)
                    {
                        // Call success function.
                        obj.success(vue, response.data);

                        // Push success message to Vue UI message handler.
						if (messageVue && messageName && obj.successMessageCallback)
						{
                            messageVue.setMessage(
                                messageName,
                                obj.successMessageCallback(response.data, response.message),
                                // If a message delay is not defined, then default to 3 seconds.
                                obj.successMessageDelay || 3000
                            );
						}
                    }
                }
                // Else, if it's safe to retry without counting against the tryCount.
				else if (response.status === 'retry')
				{
					$.ajax(this);

					return;
				}
                // Else, if redirect.
				else if (response.status === 'redirect')
				{
                    window.location = response.url;

					return;
				}
                // Otherwise, if application error.
                else
                {
                    /**
                     * If a callback is defined, then get the message based on the data,
                     * otherwise default to the application message.
                     */
                    let responseMessage =
                        (obj.errorMessageCallback) ?
                            obj.errorMessageCallback(response.data, response.message) :
                            response.message;

                    // Push error message to Vue UI message handler.
                    if (messageVue && messageName && responseMessage != '')
                    {
                        messageVue.setMessage(
                            messageName,
                            responseMessage,
                            // If a message delay is not defined, then default to 3 seconds.
                            obj.errorMessageDelay || 6000,
                            true
                        );
                    }

					// If an error function is defined.
					if (obj.error)
					{
						// If it's a validation error, then include the fields that failed validation.
						if (response.status === 'validation_error')
						{
							obj.error(vue, response.status, response.message, response.fields);
						}
						else
						{
							obj.error(vue, response.status, response.message);
						}
					}
                }

                // Call default function.
                if (obj.default)
                {
                    obj.default(vue, response.data);
                }
            }.bind(this),// success()

            // On non-application error.
            error: function(jqXHR, textStatus, errorThrown)
            {
                var newCsrfToken = jqXHR.getResponseHeader('X-CSRF-TOKEN');

                if (newCsrfToken)
                {
                    // Update the meta tag
                    $('meta[name="csrf-token"]').attr('content', newCsrfToken);

                    Laravel.csrfToken = newCsrfToken;

                    // Update AJAX setup with the new token
                    $.ajaxSetup({
                        headers: {
                            'X-CSRF-TOKEN': newCsrfToken
                        }
                    });
                }

                this.ajaxRunning[obj.url] = false;

                // If the request timed out, then try again.
            	if (textStatus === 'timeout')
				{
					this.tryCount++;

					if (this.tryCount <= 3)
					{
						$.ajax(this);

						return;
					}
				}

				// Call error function.
                if (obj.error)
                {
                    if (jqXHR.responseJSON)
                    {
                        obj.error(vue, jqXHR.responseJSON.status, jqXHR.responseJSON.message);
                    }
                    else
                    {
                        obj.error(vue, 'unexpected_error', 'There was an unexpected error');
                        console.log(jqXHR);
                    }
                }

                // Call default function.
                if (obj.default)
                {
                    obj.default(vue, null);
                }

                // Push error message to Vue UI message handler.
                let errorMessage = '';

                // This is a mistake? Request is successful but error() is called.
            	if (jqXHR.status == 200)
                {
                    console.log('Successful Request, but error() called', obj, jqXHR);
                    return;
                }
                // If the CSRF token doesn't match, then refresh the page.
            	else if (jqXHR.status == 419)
                {
                    console.log('Token Mismatch Exception', obj, jqXHR);
                    location.reload();
                }
                else if (jqXHR.responseJSON)
                {
                    errorMessage = jqXHR.responseJSON.message || jqXHR.responseText;
                }
                else
                {
                    console.log(jqXHR);
                }

				if (messageVue && messageName && errorMessage !== '')
				{
                    messageVue.setMessage(messageName, errorMessage, 6000, true);
				}
            }.bind(this)// error()
        });// $.ajax
    },// ajax

    /**
     * This method implements PHP's trim() method.
     *
     * @param str
     * @returns string
     */
    trim: function(str)
    {
        return str.replace(/\s+/, "");
    },

    /**
     * This method implements PHP's ltrim() method.
     *
     * @param str
     * @returns string
     */
    rtrim: function(str)
    {
        return str.replace(/\s+$/, "");
    },

    /**
     * This method implements PHP's rtrim() method.
     *
     * @param str
     * @returns string
     */
    ltrim: function(str)
    {
        return str.replace(/^\s+/, "");
    },

    /**
     * Courtesy of https://stackoverflow.com/questions/11076975/how-to-insert-text-into-the-textarea-at-the-current-cursor-position
     *
     * @param myField
     * @param myValue
     */
    insertAtCursor: function(myField, myValue) {
        //IE support
        if (document.selection) {
            myField.focus();
            sel = document.selection.createRange();
            sel.text = myValue;
        }
        //MOZILLA and others
        else if (myField.selectionStart || myField.selectionStart == '0') {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos)
                + myValue
                + myField.value.substring(endPos, myField.value.length);
            myField.selectionStart = startPos + myValue.length;
            myField.selectionEnd = startPos + myValue.length;
        } else {
            myField.value += myValue;
        }
    }
};
